export default class AnnotationCard extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-annotation-card', AnnotationCard);
